import {createLogger} from '@alwatr/logger';

export const logger = createLogger('alwatr/util');
